import { fetchRentalCar } from '@/api/service'
const getRentalCar = (context) => {
  fetchRentalCar().then((response) => {
    context.commit('RENTALCAR_UPDATED', response)
  })
}

export default {
  getRentalCar
}
